module.exports = __webpack_public_path__ + "static/media/icon4.b1ee72b4.svg";